import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-jira-error-modal',
  templateUrl: './jira-error-modal.component.html',
  styleUrls: ['./jira-error-modal.component.less']
})
export class JiraErrorModalComponent implements OnInit {
  @Input() errorList: any;
  @Input() testcaseDetails: any;
  errorsArray: any
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
      this.errorsArray = Object.entries(this.errorList).map(([key, value]) => ({ key, value }));
  }

}
